import React, { createContext, useContext, useState, ReactNode } from 'react';
import { Language, Translations, translations } from './translations';

interface LocalizationContextType {
  language: Language;
  t: Translations;
  changeLanguage: (lang: Language) => void;
}

const LocalizationContext = createContext<LocalizationContextType | undefined>(undefined);

interface LocalizationProviderProps {
  children: ReactNode;
}

export const LocalizationProvider: React.FC<LocalizationProviderProps> = ({ children }) => {
  const [language, setLanguage] = useState<Language>('uk'); // Ukrainian as default

  const changeLanguage = (lang: Language) => {
    setLanguage(lang);
  };

  const t = translations[language];

  return (
    <LocalizationContext.Provider value={{ language, t, changeLanguage }}>
      {children}
    </LocalizationContext.Provider>
  );
};

export const useLocalization = (): LocalizationContextType => {
  const context = useContext(LocalizationContext);
  if (context === undefined) {
    throw new Error('useLocalization must be used within a LocalizationProvider');
  }
  return context;
};